/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CartState } from './cartState'
export * from './cartState'

export interface CartDto<Item> {
	items?: Array<Item>;
	state: CartState;
}

import { GlitterCartItemDto } from './glitterCartItemDto'
export * from './glitterCartItemDto'
export interface GlitterCartDto extends CartDto<GlitterCartItemDto> {}

import { ShopCartItemDto } from './shopCartItemDto'
export * from './shopCartItemDto'
export interface ShopCartDto extends CartDto<ShopCartItemDto> {}